import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=1c71c23b"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"
import style0 from "./goods.vue?vue&type=style&index=0&id=1c71c23b&prod&lang=scss&scord=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports